import { useEffect, useState } from "react";
import { db } from "../firebase/config";
import { doc, getDoc } from "firebase/firestore";

/* ===========================
    FALLBACK DEFAULT
   =========================== */
const FALLBACK_CONFIG = {
  horario_texto:
    "Lunes a viernes de 7:30 a 20:00 hrs. Sábados y domingos cerrado.",
  ubicacion_texto: "Tabancura 1091, oficina 325, Vitacura, Santiago, Chile",
  instagram: "https://instagram.com/ekine.cl",
  whatsapp: "+56976604702",
  googleMaps: "https://maps.app.goo.gl/sV7o2kLH55UCWwxX6",
  map_embed: `<iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4003.926992513893!2d-70.5348328!3d-33.38294589999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c9e89ea96c37%3A0xaa824f77b0666a66!2sTabancura%201091!5e1!3m2!1ses!2scl!4v1764216035785!5m2!1ses!2scl"
        style="border:0;width:100%;height:100%;"
        allowfullscreen=""
        loading="lazy"
      ></iframe>`,
};

/* ===========================
   HOOK OPTIMIZADO
   =========================== */
export default function useConfigSitio() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ===========================
        1. LEER LOCALSTORAGE
     =========================== */
  useEffect(() => {
    const cached = localStorage.getItem("config_sitio");
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        setConfig({ ...FALLBACK_CONFIG, ...parsed });
        setLoading(false);
      } catch {}
    }
  }, []);

  /* ===========================
        2. CARGA FIRESTORE
        con TIMEOUT anti-colgues
     =========================== */
  useEffect(() => {
    let timeout = null;
    let isMounted = true;

    async function loadFromFirestore() {
      try {
        // Timeout de seguridad: si Firestore no responde en 4s → usar fallback/ls
        timeout = setTimeout(() => {
          if (isMounted) {
            console.warn("Firestore timeout — usando cache/fallback");
            setLoading(false);
          }
        }, 4000);

        const ref = doc(db, "editar_sitio", "config_global");
        const snap = await getDoc(ref);

        clearTimeout(timeout);

        if (!snap.exists()) {
          console.warn("⚠️ No existe config/sitio → usando fallback");
          if (isMounted) {
            setConfig(FALLBACK_CONFIG);
            setLoading(false);
          }
          return;
        }

        const data = snap.data() || {};

        const merged = { ...FALLBACK_CONFIG, ...data };

        if (isMounted) {
          setConfig(merged);
          setLoading(false);
        }

        // Guardar en localStorage
        localStorage.setItem("config_sitio", JSON.stringify(data));
      } catch (e) {
        clearTimeout(timeout);
        console.error("Error cargando config sitio:", e);

        if (isMounted) {
          // usar caché o fallback
          const cached = localStorage.getItem("config_sitio");
          if (cached) {
            setConfig(JSON.parse(cached));
          } else {
            setConfig(FALLBACK_CONFIG);
          }
          setLoading(false);
        }
      }
    }

    loadFromFirestore();

    return () => {
      isMounted = false;
      clearTimeout(timeout);
    };
  }, []);

  return { config, loading };
}
